/**
 * @generated SignedSource<<9fd9aca82201756ce45ead065ba7d5e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommunicationHistoryPage_study$data = {
  readonly emails: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"StudyEmailCard_card">;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "CommunicationHistoryPage_study";
};
export type CommunicationHistoryPage_study$key = {
  readonly " $data"?: CommunicationHistoryPage_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommunicationHistoryPage_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommunicationHistoryPage_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StudyEmailNodeConnection",
      "kind": "LinkedField",
      "name": "emails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StudyEmailNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StudyEmailNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "StudyEmailCard_card"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "39a558f97b66d959cec827067c5f7de5";

export default node;
